/**
 * Der · Die · Das: the word, pick the article.
 *
 * The interaction lives in `ArticleChoiceFront`, shared with Gêneros — the
 * Portuguese deck asking the same question with two buttons instead of three.
 */
import { ArticleChoiceFront } from '@/components/practice/GenderedNounCard';
import type { NounsPayload } from '@/core/types';
import { GERMAN_ARTICLES } from '@/lib/gender';

import type { CardFrontProps } from '../types';

export function CardFront({ card, onAnswer }: CardFrontProps<NounsPayload>) {
  return <ArticleChoiceFront card={card} onAnswer={onAnswer} articles={GERMAN_ARTICLES} />;
}
